import { IgProfileType } from '../../InstagramPostTypeBlock/InstagramPostTypeBlock.controller';
import { MediaType, PostPublishMethod } from '../../../../models/graphql';

export type PostData = {
  profileType?: IgProfileType;
  media?: {
    type: MediaType;
    filesize: number | undefined | null;
    width: number;
    height: number;
    videoLength: number | null;
  } | null;
  publishingMethod: PostPublishMethod | null;
  feedType: 'feed/reel' | 'story';
  hasPostText?: boolean;
  hasMobile?: boolean;
  hasDirectPublishProfile?: boolean;
  hasProfileWithoutDirectPublish?: boolean;
  hasMultipleMedia?: boolean;
};

export const RulesNameInfoBoxValues = [
  'creatorStoryManual',
  'cropDirectImageStoryMidTall',
  'cropDirectImageStoryTall',
  'cropDirectImageStoryWide',
  'cropDirectVideoStoryMidTall',
  'cropDirectVideoStoryTall',
  'cropDirectVideoStoryWide',
  'DirectAndEmailReminder',
  'DirectAndMobileReminder',
  'directStoryNoCaptions',
  'directVideoOver15Mins',
  'directVideoOver15MinsTall',
  'directVideoOver15MinsWide',
  'EnableDirectPublishHaveMobile',
  'EnableDirectPublishNoMobile',
  'forceReminder',
  'manualStoryA',
  'manualStoryB',
  'manualVideoOver15MinsA',
  'manualVideoOver15MinsB',
  'MultiImageFeedCrop',
  'MultiImageStoryManual',
  'tallFeedImage',
  'tallFeedVideo',
  'videoStoryOver60Sec',
  'videoUnder3Sec',
  'wideFeedImage',
  'wideManualFeedVideoA',
  'wideManualFeedVideoB'
] as const;

export type RulesNameInfoBox = (typeof RulesNameInfoBoxValues)[number];
